<template>
    <div class="data-container">
        <div class="tool-box">
            <el-button type="primary" :icon="Refresh" @click="getTableData">刷新</el-button>
            <!-- <el-button type="primary" plain @click="onAddClick()" v-permission="['module:add']" size="small" :icon="Plus">添加</el-button> -->
            <el-button :icon="Sort" v-permission="['module:sort']" @click="handleSort">一键排序</el-button>
        </div>
        <el-table class="data-table" :data="table_data">
            <el-table-column label="序号" width="60" type="index" />
            <el-table-column prop="id" width="200" label="标识ID"></el-table-column>
            <el-table-column prop="name" label="模块名称"></el-table-column>
            <el-table-column prop="list_order" label="排序值" width="130">
                <template #default="scope">
                    <el-input-number
                        style="width: 100px"
                        type="number"
                        v-model="scope.row.list_order"
                        :min="0"
                        :max="999999"
                        controls-position="right"
                        size="small"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="preset" label="预设" width="80">
                <template #default="{ row }">
                    <el-tag v-if="row.preset">是</el-tag>
                    <el-tag v-else type="info">否</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
                <template #default="{ row }">
                    <el-switch
                        v-model="row.status"
                        :disabled="row.id == 'base'"
                        :active-value="1"
                        :inactive-value="0"
                        @change="(val) => handleStatus(val, row)"
                        style="--el-switch-on-color: #13ce66"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="visible" label="是否显示" width="80">
                <template #default="{ row }">
                    <el-tag v-if="row.visible">显示</el-tag>
                    <el-tag v-else type="info">隐藏</el-tag>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="status" width="80" align="center" label="状态">
                    <template #default="{ row }">
                        <el-tag v-if="row.status" >启用</el-tag>
                        <el-tag v-else type="info" >禁用</el-tag>
                    </template>
                </el-table-column> -->
            <el-table-column label="操作" fixed="right" width="150">
                <template #default="{ row }">
                    <el-button type="primary" :icon="View" link @click="onShowClick(row)" v-permission="['module:edit']">
                        查看
                    </el-button>
                    <el-button type="primary" :icon="Edit" link @click="onEditClick(row)" v-permission="['module:edit']">
                        编辑
                    </el-button>
                    <el-button v-if="!row.preset" type="danger" @click="onRemoveClick(row)" v-permission="['module:remove']">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 50]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
        <forms-dialog v-model="formDialogVisible" :isForm="isForm" :modId="selectModId" @updateForm="getTableData"></forms-dialog>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { batchDisable, batchEnable, batchSort, delModule, getModuleLists } from '@/api/module'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Edit, Refresh, Sort, View } from '@element-plus/icons'

// 数据相关
const table_data = ref([])
const total = ref(0)
const page = ref(1)
const size = ref(10)
// 获取数据的方法
const getTableData = async () => {
    const result = await getModuleLists({
        page: page.value,
        page_size: size.value
    })
    table_data.value = result.lists
    total.value = result.total
}
onMounted(() => {
    getTableData()
})

// 分页相关
/**
 * size 改变触发
 */
const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getTableData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModId = ref('') // 点中的模块id
// 保证每次打开重新获取用户角色数据
watch(formDialogVisible, (val) => {
    if (!val) selectModId.value = ''
})
// 查看
const onShowClick = (row) => {
    selectModId.value = row.id
    isForm.value = false
    formDialogVisible.value = true
}
// 编辑
const onEditClick = (row) => {
    selectModId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
// const onAddClick = () => {
//     selectModId.value = ''
//     isForm.value = true
//     formDialogVisible.value = true
// }
// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    }).then(async () => {
        await delModule(row.id)
        ElMessage.success('删除成功！')
        // 重新渲染数据
        getTableData()
    })
}

// 修改岗位状态
const handleStatus = (val, row) => {
    if (!row.id) return
    const msg = val ? '启用' : '停用'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.name}"角色吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            if (val) {
                await batchEnable([row.id])
            } else {
                await batchDisable([row.id])
            }
            ElMessage({
                type: 'success',
                message: msg + '成功'
            })
        })
        .catch(() => {
            row.status = val ? 0 : 1
        })
}

const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        soreObj[ele.id] = ele.list_order
    })
    await batchSort(soreObj)
    ElMessage.success('操作成功')
    getTableData()
}
</script>

<style lang="scss" scoped></style>
